import itemsJson from '../../../server/api/data/items.json';
import { type CatalogItem, mysteryItem, parseCatalogItem } from '../models/types';
import { Logger } from '../services/logger';

const log = new Logger('Catalog');

/** The bundled item catalog: one file shared with the server and the Flutter app. */
export class Catalog {
  readonly items: readonly CatalogItem[];
  private readonly byId: Map<string, CatalogItem>;

  constructor(
    readonly version: number,
    items: CatalogItem[],
  ) {
    this.items = items;
    this.byId = new Map(items.map((i) => [i.id, i]));
  }

  /** Never throws: unknown ids render as a "Mystery Item". */
  get(id: string): CatalogItem {
    const item = this.byId.get(id);
    if (!item) {
      log.warn('item not in bundled catalog', { itemId: id, catalogVersion: this.version });
      return mysteryItem(id);
    }
    return item;
  }

  contains(id: string): boolean {
    return this.byId.has(id);
  }

  static parse(json: { version: number; items: Record<string, unknown>[] }): Catalog {
    return new Catalog(json.version, json.items.map(parseCatalogItem));
  }
}

export const catalog = Catalog.parse(itemsJson as unknown as { version: number; items: Record<string, unknown>[] });
